// /src/pages/admin/EmailRecuperationPassword.js
import React, { Suspense, lazy } from "react";
import useEmailRecuperation from "./hooks/useEmailRecuperation";
import SpinnerNoPercet from "../../components/common/SpinnerNoPercet";

const EmailRecuperationForm = lazy(() =>
  import("./components/EmailRecuperationForm")
);

const VerifyRecuperationCodeForm = lazy(() =>
  import("./components/VerifyRecuperationCodeForm")
);

const GeneratePassForm = lazy(() => import("./components/GeneratePassForm"));

const EmailRecuperationPassword = () => {
  const { step, handleVerifyEmail, handleVerifyCode, handleChangePassword } =
    useEmailRecuperation();

  return (
    <>
      <article className="login-container">
        <section className="login-form-section">
          <Suspense fallback={<SpinnerNoPercet />}>
            {step === 1 && (
              <EmailRecuperationForm handleVerifyEmail={handleVerifyEmail} />
            )}
            {step === 2 && (
              <VerifyRecuperationCodeForm handleVeryfyCode={handleVerifyCode} />
            )}
            {step === 3 && (
              <GeneratePassForm handleChangePass={handleChangePassword} />
            )}
          </Suspense>
        </section>
      </article>
    </>
  );
};

export default EmailRecuperationPassword;
